<mat-icon [matTooltip]="tooltip()" class="icon" [class.fill]="fill()">
  <ng-content></ng-content>
</mat-icon>
